<template>
    <div id="app">
        <el-container>
            <el-header v-if="$route.meta.navShow"  class="phone-nav" :style="'transition: all 1s;background-color: rgba('+color+',' +tm+');'">
                <div class="flex justify-between  zho align-center" style="max-width: 1180px;margin: 0 auto; ">
                    <img src="./assets/svg/logo.svg" alt="" class="phone-logo cursor-pointer"  @click="$router.push({path: '/' ,query: {}})">
                    <div class="flex justify-center self-center searchNav">
                        <input type="text " placeholder="搜索项目名称或者编号" v-model="searchValue" class="search-in">
                        <button class="search-bt">
                            <span class="search-sp cuIcon-search cursor-pointer" @click="search()">搜索</span>
                        </button>
                    </div>
                    <img src="./assets/svg/search.svg" class="phoneSearch" width="21" alt="" @click="$router.push({path: '/search' ,query: {}})">
                </div>
            </el-header>
            <el-header v-show="!$route.meta.full" v-if="!$route.meta.navShow " class="phone-nav" style="position: static;background-color: rgba(51, 51, 51,1);">
                <div class="flex justify-between  zho" style="max-width: 1180px;margin: 0 auto; ">
                    <img src="./assets/svg/logo.svg" alt="" class="phone-logo cursor-pointer" @click="$router.push({path: '/' ,query: {}})">
                    <div class="flex justify-center self-center searchNav">
                        <input type="text " placeholder="搜索项目名称或者编号" v-model="searchValue" class="search-in">
                        <button class="search-bt">
                            <span class="search-sp cuIcon-search" @click="search()">搜索</span>
                        </button>
                    </div>
                    <img src="./assets/svg/search.svg" class="phoneSearch" width="21" alt="" @click="$router.push({path: '/search' ,query: {}})">
                </div>
            </el-header>
            <el-main>
                <transition>
                    <router-view v-if="showState"></router-view>
                </transition>
            </el-main>
            <div class="cebianl" v-if="!$route.meta.full"  style="cursor: pointer;">
                <div class="cebianl-item" @mousemove="isCheckxs(1)" @mouseleave="noCheckxs(1)">
                    <img v-if="!cbStatus1" src="./assets/svg/wx.svg" alt="">
                    <img v-else src="./assets/svg/wx1.svg" alt="">
                    <div class="font-15" style="color: #333">公众号</div>
                </div>
                <div class="cebianl-item" @mousemove="isCheckxs(2)" @mouseleave="noCheckxs(2)">
                    <img v-if="!cbStatus2" src="./assets/svg/kf.svg" alt="">
                    <img v-else src="./assets/svg/kf1.svg" alt="">
                    <div class="font-15" style="color: #333">客服</div>
                </div>
                <a href="#app"><div class="cebianl-item" @mousemove="isCheckxs(3)" @mouseleave="noCheckxs(3)">
                    <img v-if="!cbStatus3" src="./assets/svg/top.svg" alt="">
                    <img v-else src="./assets/svg/top1.svg" alt="">
                    <div class="font-15" style="color: #333">回顶部</div>
                </div></a>
            </div>
            <div>
                <div class="gzherw" :class="cbStatus1?'display-block':''" style="border-radius: 5px;display: none;position: fixed;right: 60px;top: 40%;height: 90px;width: 80px;font-size: 13px;">
                    <!-- <img style="box-shadow: -3px 0px 12px rgba(60, 60, 67, 0.176470588235294);height: 80px;width: 80px;background-size: 100% 100%" src="./assets/png/wxgzh.png" alt=""> -->
                    <img style="box-shadow: -3px 0px 12px rgba(60, 60, 67, 0.176470588235294);height: 80px;width: 80px;background-size: 100% 100%"  src="./assets/png/gz_qrcode.jpg" alt="">
                    <div>微信扫一扫</div>
                </div>
                <div  :class="cbStatus2?'display-block':''" style="box-shadow: -3px 0px 12px rgba(60, 60, 67, 0.176470588235294);display: none;position: fixed;right: 60px;top: 47%;width: 150px;font-size: 13px;background-color: white;border-radius: 5px;">
                    <div class="text-gray" style="padding: 5px">客服电话</div>
                    <div  style="padding: 5px">400-848-8897</div>
                </div>
            </div>
            <el-footer v-if="!$route.meta.full">
                <div class="footer-content">
                    <div class="footer-v1">
                        <img class="logo" src="./assets/svg/logo.svg" alt="">
                        <img class="fgf" src="./assets/svg/fgf.svg" alt="">
                        <div >
                            <div style="padding-bottom: 5px;">主办单位：贵州省农村资源资产权益交易中心有限责任公司</div>
                            <div style="padding-bottom: 5px">服务热线：400-848-8897</div>
                            <div style="padding-bottom: 5px">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：center@gzrrtc.com</div>
                        </div>
                        <img class="fgf mt2fgf" src="./assets/svg/fgf.svg" alt="">
                        <div class="ewmG flex justify-center">
                            <!-- <div>
                                <img src="./assets/png/erwm.png" alt="">
                                <div style="line-height: 12px">农交中心</div>
                            </div> -->
                            <div>
                                <!-- <img src="./assets/png/erwm.png" alt=""> -->
                                <img src="./assets/png/gz_qrcode.jpg" alt="">
                                <div style="line-height: 12px">微信公众号</div>
                            </div>
<!--                            <div style="margin-right: 0">-->
<!--                                <img src="./assets/png/erwm.png" alt="">-->
<!--                                <div style="line-height: 12px">微博</div>-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div class="footer-v2" style="color: #ff5c38">
                        <li class="phoneFooter" v-for="(item,i) in footerData" :key="i" style="list-style: none">{{item}}</li>

                    </div>
                    <div style="height: 0.125rem  /* 2/16 */;width: 100%;background-color: #666;margin:10px auto " ></div>
                    <div style="font-size: 0.625rem  /* 10/16 */;line-height: 1.5625rem  /* 25/16 */;color: #b6b6b6">
                        <span class="lf phone-hi" style="padding-right: 0.9375rem  /* 15/16 */;white-space: nowrap;">Copyright © 2021 贵州省农交中心</span>
                        <span class="lf" style="padding-right: 0.9375rem  /* 15/16 */;white-space: nowrap;">黔ICP备20200088965号-4</span>
                            <!-- 占时隐藏-->
                        <span v-show="false" class="lf" style="padding-right: 0.9375rem  /* 15/16 */;white-space: nowrap;"><img style="height: 1.25rem;width: 1.25rem" src="./assets/png/gg.png"  alt="">黔ICP备20200088965号-4</span>
                    </div>
                </div>
            </el-footer>
        </el-container>
    </div>
</template>

<script>
    import HelloWorld from './pages/vrView/vrView.vue'

    export default {
        name: 'app',
        components: {
            // eslint-disable-next-line vue/no-unused-components
            HelloWorld
        },
        data(){
          return{
              searchValue:'',
              tm:.1,
              color:'255, 255, 255',
              footerData:['400-848-8897','center@gzrrtc.com','贵州省农村资源资产权益交易中心'],
              showState:true,
              cbStatus1:false,
              cbStatus2:false,
              cbStatus3:false,
          }
        },
        created() {
            // 回到顶部
            document.documentElement.scrollTop = 0
            document.body.scrollTop = 0;

            this.searchs
            // this.$notify({title: 'admin',message: '欢迎回来史诗由你开始!',type: 'success'});
            this.main();
            console.log('编译测试')
            // 10以下
            var ua = navigator.userAgent;
            var ie = (ua.toLowerCase().indexOf("msie") !== -1);
            // ie6~11
            if (!!window.ActiveXObject || "ActiveXObject" in window){
                console.log(true)
                this.$notify({title: '温馨提示',message: '请您使用IE11以上或谷歌、火狐等浏览器！',type: 'success'});
            }else{
                console.log(false)
            }
            if (ie) {
                this.$notify({title: '温馨提示',message: '请您使用IE11以上或谷歌、火狐等浏览器！',type: 'success'});
            }
            // this.MouseWheelHandler()
            this.main()
                this.TitleScrolling()
        },
        methods: {
            //侧边栏
            isCheckxs(i){
                console.log('鼠标',i)
                if(i ===1){
                    this.cbStatus1 = true
                }
                if(i ===2){
                    this.cbStatus2 = true
                }
                if(i ===3){
                    this.cbStatus3 = true
                }
            },
            noCheckxs(i){
                console.log('鼠标没了',i)
                if(i ===1){
                    this.cbStatus1 = false
                }
                if(i ===2){
                    this.cbStatus2 = false
                }
                if(i ===3){
                    this.cbStatus3 = false
                }
            },
            // 滚动的head标题
            TitleScrolling (){
                var tit = document.title
                // 截取首字符串(第一个)
                var head = tit.substring(0,1);
                // 截取除首字符串外所有字符串(除第一个所有)
                var foot = tit.substring(1);
                // 头尾拼接后赋给data => tit属性
                 tit = foot + head;
                document.title = tit

                setTimeout(()=>{
                    this.TitleScrolling()
                },500)
            },
            reload(){
                this.showState = false;
                this.$nextTick(()=>{
                    this.showState = true;
                })
            },
            search(){
                if(this.searchValue.length >0){
                    this.reload()
                    this.$router.push({path: '/searchInfo' ,query: {key: this.searchValue}})
                }else{
                    this.$message({
                        message: '您还没有输入搜索内容哦！',
                        type: 'warning'
                    });
                }

            },
            // 监听浏览器滚动事件
            main() {
                console.log('main')
                // var app = document.getElementsByClassName('el-main')
                //addEventListener适用于版本较新的IE浏览器 ，如IE9以及火狐浏览器，
                document.addEventListener("mousewheel", this.MouseWheelHandler, false);
                // Firefox浏览器使用的滚轮事件是 DOMMouseScroll
                document.addEventListener("DOMMouseScroll", this.MouseWheelHandler, false);
                document.addEventListener('scroll', this.MouseWheelHandler, true);
            },
            // 获得滚动的值
            MouseWheelHandler() {
                let scrollTop = 0;
                if (document.documentElement && document.documentElement.scrollTop) {
                    scrollTop = document.documentElement.scrollTop;
                } else if (document.body) {
                    scrollTop = document.body.scrollTop;
                }
                // console.log(scrollTop)
                //443
                this.lucencyJS(scrollTop)
            },
            // 计算透明
            lucencyJS(scrollTop){
                if(scrollTop >= 443){
                    this.color='51, 51, 51'
                    this.tm = 1
                }else if(scrollTop >=398){
                    this.color='51, 51, 51'
                    this.tm = .9
                }else if(scrollTop >=354){
                    this.color='51, 51, 51'
                    this.tm = .8
                }else if(scrollTop >=310){
                    this.color='51, 51, 51'
                    this.tm = .7
                }else if(scrollTop >=265){
                    this.color='51, 51, 51'
                    this.tm = .6
                }else if(scrollTop >=221){
                    this.color='51, 51, 51'
                    this.tm = .5
                }else if(scrollTop >=177){
                    this.color='51, 51, 51'
                    this.tm = .4
                }else if(scrollTop >=132){
                    this.color='51, 51, 51'
                    this.tm = .3
                }else if(scrollTop >=88){
                    this.color='51, 51, 51'
                    this.tm = .2
                }else if(scrollTop >=44){
                    this.color = '255, 255, 255';
                    this.tm = .1
                }
            }
        },
        beforeDestroy() {
            document.removeEventListener("mousewheel", this.MouseWheelHandler);
            document.removeEventListener("DOMMouseScroll", this.MouseWheelHandler);
            document.removeEventListener("scroll", this.MouseWheelHandler);
        },
    }
</script>

<style>
    /*<div class="cuIcon-homefill">test</div>*/
    @import "./util/colorui/icon.css";
    @import "./util/colorui/animation.css";
    @import "./util/colorui/main.css";
    *{
        /*touch-action: auto;*/
    }
    input:focus, textarea:focus {
        outline: none;
    }
    .el-icon-circle-close{
        color: #fff;
    }
    .cursor-pointer{
        cursor: pointer;
    }
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    body,html{
        scroll-behavior: smooth;
        transition: all 1ms;
    }
    body {
        margin: 0 auto;
    }
    /*包含以下四种的链接*/
    a {
        text-decoration: none;
    }
    /*正常的未被访问过的链接*/
    a:link {
        text-decoration: none;
    }
    /*已经访问过的链接*/
    a:visited {
        text-decoration: none;
    }
    /*鼠标划过(停留)的链接*/
    a:hover {
        text-decoration: none;
    }
    /* 正在点击的链接*/
    a:active {
        text-decoration: none;
    }
    .el-header{
        line-height: 0!important;
    }
    .cebianl{
        width: 50px;
        /*height: 170px;*/
        background-color: #fff; position: fixed;right: 0;top: 40%;
        box-shadow: -3px 0px 12px rgba(60, 60, 67, 0.176470588235294);
        border-radius: 5px;
    }
    .cebianl-item >img{
        padding:10px;
    }
    .cebianl-item{
        height: 60px;
    }

    .display-block{
        display: block !important;
    }
    .cebianl-item:hover div{
        color: #fff !important;}
    .cebianl-item:hover{
        color: #fff !important;
        background-color: #ff5c38;
        border-radius: 5px;
    }
    .v-enter-active, .v-leave-active {
        transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .v-enter, .v-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .el-header {
        line-height: 60px;
        /*position: sticky;*/
        position: fixed;
        width: 100%;
        height: 4rem !important;  /* 64/16 */;
        top: 0;
        z-index: 10;
    }
    .zho{
        height: 100%;
    }
    .el-header >img {
        line-height: 60px;
        position: relative;
        top: 0.75rem  /* 12/16 */;
        width: 20.0625rem  /* 321/16 */;
        height: 2.5rem  /* 40/16 */;  /* 64/16 */;
    }

    .el-footer {
        height: 11.875rem !important; /* 190/16 */;
    }

    .el-header, .el-footer {
        background-color: rgba(51, 51, 51, 1);
        color: #fff;
        text-align: center;
    }

    .el-main {
        background-color: #f1f1f1;
        color: #333;
        text-align: center;
        padding: 0 !important;
    }
    .search-in{
        width: 20.8125rem  /* 333/16 */;
        height: 2.09rem  /* 36/16 */;
        background: inherit;
        background-color: rgba(255, 255, 255, .1);
        border-style:none;
        border-radius: 100px 0 0 100px ;
        font-size: 15px;
        font-weight: 400;
        padding-left: 20px;
        color: #fff;
    }
    .search-in::placeholder {
        /* Mozilla Firefox 19+ */
        color: #fff;
    }
    .search-bt{
        border-radius: 0 100px 100px 0;
        background-color: rgba(255, 92, 56, 1);
        width: 4.8125rem  /* 77/16 */;
        height: 2.25rem  /* 36/16 */;
        border-style:none;

    }
    .search-bt:focus{outline:0;}
    .search-sp{
        color: #fff;
        line-height: 1.13rem;
    }
    .search-sp::before{
        font-size: 21px;
        padding: 0.125rem  /* 2/16 */;
    }
    .footer-content{
        margin: 0 auto;
    }
    .fgf{
        padding-left:3rem  /* 48/16 */;
        padding-right:3rem  /* 48/16 */;
    }
    .footer-v1{
        margin-top: 2.3125rem  /* 37/16 */;
        width: inherit;
        /*background-color: blue;*/
        height: 6.25rem  /* 100/16 */;
    }
    .logo{
        width: 20.0625rem  /* 321/16 */;
        height: 2.5rem  /* 40/16 */;  /* 64/16 */;
    }
    .footer-v1{
        display: flex;
        justify-content: center;
    }
    .footer-v1 >div>*{
        list-style: none;
        text-align: left;
    }
    .ewmG>div>img{
        width: 5rem  /* 80/16 */;
        height: 5rem  /* 80/16 */;
    }
    .ewmG > div{
        text-align: center;
        margin-right: 1.0625rem  /* 17/16 */;
    }
    .phoneFooter{
        font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #FFFFFF;
        padding-bottom: 5px;
    }
    .phoneFooter:nth-child(1){
        font-size: 18px;
        padding-top: 15px;
        padding-bottom: 15px;
        font-weight: 600;
    }
    .phoneFooter:nth-child(3){
        padding-bottom: 15px;
    }
    /*全局媒体查询*/
    @media only screen and (max-width: 767px) {
        .title-v{
            font-size: 16px;
        }
        .v-enter-active, .v-leave-active {
            /*transition: all .8s ease-in-out;*/
            /*transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
            /*transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
        }
        .v-enter, .v-leave-to /* .fade-leave-active below version 2.1.8 */ {
            /*opacity: 0;*/
            /*transform: translateX(100px);*/
            /*transform: translateX(10px) translateY(20px) rotate3d(1,1,2,45deg) scale(.5);*/
        }
        .vr-fff{
            grid-template-columns: repeat(2,224px) !important;
        }
        .grid-body:first-child{
            grid-column: 1 / 1;
            /*max-width: 464px;*/
        }
        .phoneSearch{
            display: flex !important;
        }
         .hyp, .searchNav{
            display: none;
        }
         .phone-vr-item{
             display: none !important;
         }
        .el-carousel__container{
            height: 170px !important;
        }
        .lb-content1{
            height: 218px !important;
        }
        .phone-lbt{
            top: -391px !important;
        }
        .content-vrs1{
            padding: 20px 20px 10px 20px;
        }
        .phone-pagination, .phone-dropdown{
            display: none !important;
        }
        .navtitle{
            margin-left: 15px ;
            margin-right: 0 !important;
        }
        .cebianl{
            display: none;
        }
    }
    @media only screen and (min-width: 768px) {
        .phone-show{
            display: none;
        }
        .navtitle{
            margin-right: 15px;
        }
    }
    @media only screen and (max-width: 992px) {
        .el-button{
            color: #000!important;
            border: 1px solid #ffffff00 !important;
            font-family: Avenir,Helvetica Neue, Helvetica, sans-serif;
            background: #ffffff00 !important;
        }
        .phone-hi{
            display: none;
        }
        .phone-logo{
            max-width: 192px;
        }
        .zho{
            height: 100%  /* 50/16 */;
        }
        .phone-nav{
            height: 48px !important;
        }
        .phoneSearch, .footer-v1{
            display: none;
        }
        .genduo{
            display: none;
        }
    }
    @media only screen and (min-width: 992px) {
        .el-carousel__arrow{
            display: none;
        }
         .mt2fgf ,.ewmG{
            display: none;
        }
        .phoneSearch, .footer-v2{
            display: none;
        }
    }

    @media only screen and (max-width: 1200px){
        .cursor-pointer{

            width: 350px;

        }
        .mianbaox{
            display: none;
        }
        .vrinfocrat{
            padding: 15px 15px;
        }
    }
    @media only screen and (min-width: 1200px) {

        .cursor-pointer{

            width: 350px;

        }

        .phoneView{
            display: none;
        }
        .mt2fgf ,.ewmG{
            display: flex;
        }
    }

    @media only screen and (min-width: 1920px) {

        .cursor-pointer{

            width: 350px;

        }

    }
</style>
